module.exports = __webpack_public_path__ + "static/media/S (122).a2d0a2e6.jpg";